import {
  regionEn,
  countryCn,
  countryEn,
  langEn,
  regionCn,
  langCn,
} from '@/pages/opinion/constants';

// import KPIs from '../KPIs';
// import OpinionsGameStore from '../OpinionsGameStore';
// import GPTReport from '../components/GPTReport';
// import OpinionsChannelLanguge from '../components/OpinionsChannelLanguge';
// import OpinionsVideo from '../components/OpinionsVideo';
// import OpinionsVideoInFluencers from '../components/OpinionsVideoInFluencers';
// import OpinionsTrendVideo from '../components/OpinionsTrendVideo';
// import OpinionsPosts from '../components/OpinionsPosts';
// import OpinionsTrendPosts from '../components/OpinionsTrendPosts';
// import OpinionsAccountsFollowers from '../components/OpinionsAccountsFollowers';
// import OpinionsAccountsOverview from '../components/OpinionsAccountsOverview';

// 【舆情子模块-优化】语言“简中”英文文案调整
// studio舆情映射语言，Simplified Chinese改为S. Chinese
// langEn 是从舆情引入，防止舆情代码修改，这里加上兜底{}
const studioLangEn: { [key: string]: string; } = {
  ...(langEn || {}),
  zh: 'S. Chinese',
  ['zh-tw']: 'T. Chinese'

};

const tipsLanguageContentMap: { [key: string]: string; } = {
  'S. Chinese': 'Simplified Chinese',
  'T. Chinese': 'Traditional Chinese',
};

// fucom 舆情页report页面参数
const commonOpinionsReportFilter = {
  "social_media_by_account": undefined,
  "social_media_by_keyword": undefined,
  "is_valid": [2, 1, 3],
};

export {
  regionEn,
  countryCn,
  countryEn,
  regionCn,
  langCn,
  studioLangEn,
  tipsLanguageContentMap,
  commonOpinionsReportFilter
};

// funcom卡片选项
export const FUNCOM_CARD_LIST = [
  { nameEn: 'Highlights', nameCn: '要点', value: 'highlights', components: [null] },
  { nameEn: 'KPIs', nameCn: 'KPIs', value: 'kpis', components: ['KPIs'] },
  { nameEn: 'Game Store', nameCn: '应用商店', value: 'gameStore', components: ['OpinionsGameStore'] },
  { nameEn: 'Player Sentiment Summary', nameCn: '情感分', value: 'playerSentimentSummary', components: ['GPTReport'] },
  { nameEn: 'Channel & Language', nameCn: '渠道&语言', value: 'channelLanguage', components: ['OpinionsChannelLanguge'] },
  { nameEn: 'Sentiment Topics Deep Dive', nameCn: '话题', value: 'sentimentTopicsDeepDive', components: [null] },
  { nameEn: 'Streaming', nameCn: '直播', value: 'streaming', components: [null] },
  { nameEn: 'Video Content', nameCn: '视频', value: 'videoContent', components: ['OpinionsTrendVideo', 'OpinionsVideoInFluencers', 'OpinionsVideo'] },
  { nameEn: 'Posts', nameCn: '帖子', value: 'posts', components: ['OpinionsPosts', 'OpinionsTrendPosts'] },
  { nameEn: 'Official Accounts Followers', nameCn: '粉丝', value: 'officialAccountsFollowers', components: ['OpinionsAccountsFollowers'] },
  { nameEn: 'Official Accounts Overview', nameCn: '官号', value: 'officialAccountsOverview', components: [null] },
  { nameEn: 'Appendix', nameCn: '附录', value: 'appendix', components: ['OpinionsAccountsOverview'] },
];

export const hideSentimentChartStudio= ["techland", "grinding_gear_games" ];

export const OPINION_FILTER_CONFIG = [
  {
    studioid: 'techland',
    componentConfig: [
      {
        name: 'GameStore',
        filter: {
          starred_tag: 1,
        },
      },
    ],
  },
];